import AliOss from 'ali-oss'

let options = {
  region: 'oss-cn-shanghai',
  accessKeyId: 'LTAI5t6aZ1HvhPVCDkgyr6k7',
  accessKeySecret: 'PTISVsF968AUyeBzEoYhOpMVR658EH',
  bucket: 'big-image-uplaod'
}

export const aliUpload = (option, file) => {
  if (option.bucket) {
    options.bucket = option.bucket
  }
  let storeAs = ''
  let prefix = option.prefix ? option.prefix : 'big-img-zx'
  let fileType = file.name.split('.')[1]
  if (option.name) {
    storeAs = `${option.name}.${fileType}`
  } else {
    storeAs = `${prefix}-${new Date().getTime()}.${fileType}`
  }
  let client = new AliOss(options)
  // let fileName = file.name
  return client.put(storeAs, file).then(res => res)
}

export const getImage = (bucket, url) => {
  options.bucket = bucket
  let client = new AliOss(options)
  return client.signatureUrl(url, { expires: 600 })
}
